import { createSelector } from 'reselect';

import { AppState } from '../../../../store/models/app-state';

export const bonusSettlementsState = (state: AppState) => state.bonusSettlements;

export const bonusSettlementsSelector = createSelector(bonusSettlementsState, state => ({
    bonusSettlements: state.overview.bonusSettlements,
    requesting: state.overview.requesting,
}));
